import { getConnection } from '@/helpers/solana/getConnection';
import { useWallet } from 'solana-wallets-vue';
import { ref, Ref, watch } from 'vue';

const isFetching = ref(false);
const finished = ref(false);
let pendingPromise: Promise<number> | null = null

const solBalance: Ref<number | null> = ref(null);

export function useSolBalance() {
  const { publicKey } = useWallet();

  watch(publicKey, async (newPublicKey) => {
    if (!newPublicKey) {
      solBalance.value = null;
      finished.value = false;
      return;
    }
    await execute()
  })

  const execute = async () => {
    if (!publicKey.value) {
      solBalance.value = null;
      finished.value = false;
      return;
    }

    if (!pendingPromise) {
      isFetching.value = true;
      pendingPromise = getConnection().getBalance(publicKey.value)
    }

    const rawBalance = await pendingPromise
    pendingPromise = null
    solBalance.value = rawBalance / (10 ** 9);
    isFetching.value = false;
    finished.value = true;
  }

  return {
    solBalance,
    isFetching,
    finished,
    execute
  }
}
